import { Layout as AntLayout, type LayoutProps } from 'antd'
import { forwardRef } from 'react'

export type UiLayoutProps = LayoutProps

const UiLayoutComponent = forwardRef<HTMLElement, UiLayoutProps>((props, ref) => (
  <AntLayout ref={ref} {...props} />
))

UiLayoutComponent.displayName = 'UiLayout'

export const UiLayout = Object.assign(UiLayoutComponent, {
  Header: AntLayout.Header,
  Content: AntLayout.Content,
  Sider: AntLayout.Sider,
  Footer: AntLayout.Footer,
})

export default UiLayout
